export const treatmentOptions = ['Metotreksat', 'Sulfasalazyna', 'NLPZ']